export enum ObjectTriggerTypes {
	VisibilityToggle = "visibilityToggle",
	MoveToStep = "moveToStep",
	CalloutToggle = "calloutToggle",
	ProjectLink = "projectLink",
	URL = "url",
	Alignment = "alignment",
	NextStep = "nextStep",
	PreviousStep = "previousStep",
}

export enum VisibilityModes {
	Hidden = "hidden",
	Custom = "custom",
	Ghosted = "ghosted",
	Solid = "solid"
}

export enum ProjectLinkModes {
	Online = "online",
	Offline = "offline",
}

export enum BillboardModes {
	Billboard = "Billboard",
	LookAt = "Look At Object",
}

export enum TemplateSortModes {
	Recent = "Recent",
	Alphabetical = "Alphabetical",
	MyTemplates = "My Templates",
	MostUsed = "Most Used",
}

export enum CsvPropertyNames {
	ObjectName = "Object Name",
	ObjectGUID = "Object GUID",
	ObjectType = "Object Type",
	Material = "Material",
	Level = "Level",
	StandaloneMode = "Standalone Mode",
	OverlayMode = "Overlay Mode",
	TransformPositionX = "Transform Position X",
	TransformPositionY = "Transform Position Y",
	TransformPositionZ = "Transform Position Z",
	TransformRotationX = "Transform Rotation X",
	TransformRotationY = "Transform Rotation Y",
	TransformRotationZ = "Transform Rotation Z",
	TransformScaleX = "Transform Scale X",
	TransformScaleY = "Transform Scale Y",
	TransformScaleZ = "Transform Scale Z",
	CalloutTitle = "Callout Title",
	CalloutTitleColor = "Callout Title Color",
	CalloutTitleBackground = "Callout Title Background",
	CalloutDescription = "Callout Description",
	CalloutDescriptionColor = "Callout Description Color",
	CalloutDescriptionBackground = "Callout Description Background",
	CalloutLineColor = "Callout Line Color",
	CalloutOffsetX = "Callout Offset X",
	CalloutOffsetY = "Callout Offset Y",
	CalloutOffsetZ = "Callout Offset Z",
	CalloutWidth = "Callout Width",
	CalloutAutoWidth = "Callout Auto Width",
	CalloutScale = "Callout Scale",
	CalloutOrigin = "Callout Origin",
	CalloutStroke = "Callout Stroke",
	CalloutStrokeColor = "Callout Stroke Color",
	CalloutEnabled = "Callout Enabled",
	CalloutDescriptionEnabled = "Callout Description Enabled",
	DeviceMode = "Device Mode",
}

export enum ByteUnits {
	Bytes = "B",
	Kilobytes = "KB",
	Megabytes = "MB",
	Gigabytes = "GB",
	Terabytes = "TB",
}

export enum HealthReportType {
	Warning = "warning",
	Error = "error",
}

export enum StepActionsViewType  {
	SEMI = 'semiHierarchy',
	FLAT = 'flat',
}

export enum HealthReportId {
	InsetReference = 1,
	InsetDisabled = 2,
	AssetsInUseSize = 3,
	ImageResolution = 4,
	VideoResolution = 5,
	StepTriangleCount = 6,
	StepObjectCount = 7,
	CustomMaterialReference = 8,
	ObjectTriggersReference = 9,
	InsetImageReference = 11,
	UIUsingBothSystems = 12,
	InvalidUrl = 13,
	MissingGradedQuestions = 5001,
	MissingQuizResultTemplate = 5002,
	ARTrackerReference = 5003,
}

export enum FeatureFlagNames {
	uiEditor2 = "ui_editor_2_0",
	partsCatalog = "parts_catalog",
	connectedServices = "iot_services",
	allowBypassCPS = "custom_uwp_scenario_options",
	aiAuthoring = "ai_authoring_companion",
	viewOnlyMode = "create_view_only",
	RevisionManagement = "revision_management",
}

export enum BuiltInTextVariables {
	ProjectName = "ProjectName",
	StepName = "StepName",
	StepNumber = "StepNumber",
	SequenceName = "SequenceName",
	StepTotal = "StepTotal",
	ObjectName = "ObjectName",
}

export enum ProjectListFilters {
	/** *DEPRECATED* as of WC20-4988 as it's functionally identical to "all_projects" sorted by "last edited" */
	recent = "recent",
	all_projects = "all_projects",
	my_projects = "my_projects",
	shared_with_me = "shared_with_me",
	demo_projects = "demo-projects",
	whats_new = "whats-new",
	admin = "admin",
	learn_and_support = "learn-and-support",
}


export enum ProjectLoadingEvents	{
	STATE = "message",
	LOADING_PERCENT = "loadingPercent"
}

export enum ProjectLoadingStates {
	NONE,
	DOWNLOADING_PROJECT_FILE,
	DOWNLOADING_ASSETS,
	LOADING_PROJECT
}

export enum LicenseFilters {
	All = "All",
	Authors = "Authors",
	Viewers = "Viewers",
}

export enum ScenarioElementTypes {
	Scenario = "Scenario",
	Sequence = "Sequence",
	Step = "Step",
	StepArray = "StepArray",
}

export enum TextAlign {
	Left = "left",
	Center = "center",
	Right = "right",
}

export enum SpecialLayoutNames {
	DefaultWorkspace = "Default Workspace",
	TimelineEditingWorkspace = "Timeline Editing Workspace",
	MultiViewWorkspace = "Multi View Workspace",
	AllWindowsWorkspace = "All Windows Workspace",
	DefaultStep = "Default Step",
	ContentPlacementStep = "Content Placement Step",
	SlideEditing = "Slide Editing",
	ViewOnly = "View Only",
	Simulation = "Simulation",
	SimulationTrackers = "Simulation Trackers",
}

export enum MenuAlignments {
	Left = "left",
	Right = "right",
}